module.exports = __webpack_public_path__ + "img/lb14.69a7b553.svg";